import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "revenuerules",
    defaultRoutePath: "/administrations/revenuerule",
    menuItemScope: "administration",
    menuItemName: "revenuerules",

    routes: [
        {
            path: "/administrations/revenuerule",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Wizards.Create,
        },
    ],

}

export default Module;
